import { render, staticRenderFns } from "./ProductModel.vue?vue&type=template&id=7c8d91fc&scoped=true"
import script from "./ProductModel.vue?vue&type=script&lang=js"
export * from "./ProductModel.vue?vue&type=script&lang=js"
import style0 from "./ProductModel.vue?vue&type=style&index=0&id=7c8d91fc&prod&lang=scss&scoped=true"
import style1 from "./ProductModel.vue?vue&type=style&index=1&id=7c8d91fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8d91fc",
  null
  
)

export default component.exports